export default "__VITE_ASSET__256e7914__"